import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "monitoring",
  "use": "monitoring-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"monitoring\"><path d=\"m13.5 9.38-2 4-.69-1.38H4v1h6.19l1.31 2.62 2-4 .69 1.38H16v-1h-1.19zM15.87 0H4.13C1.85 0 0 1.85 0 4.13v11.74C0 18.15 1.85 20 4.13 20h11.74c2.28 0 4.13-1.85 4.13-4.13V4.13C20 1.85 18.15 0 15.87 0M18 15.87c0 1.17-.96 2.13-2.13 2.13H4.13C2.96 18 2 17.04 2 15.87V4.13C2 2.96 2.96 2 4.13 2h11.74C17.04 2 18 2.96 18 4.13zM9.5 4.38l-2 4L6.81 7H4v1h2.19l1.31 2.62 2-4L10.19 8H16V7h-5.19z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol